import { useCallback } from 'react';
import { useTranslations } from 'js/hooks/i18n';
import { ITranslateMethod } from 'js/hooks/i18n/types';
import { IServerError, IServerErrorActions } from 'js/hooks/socket/types';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

export const useGetErrorMessage = ({
    tkPrefix,
    translate: customTranslate
}: {
    tkPrefix?: string;
    translate?: ITranslateMethod;
} = {}) => {
    const componentTranslate = useComponentTranslations();
    const translateWithCustomTK = useTranslations(tkPrefix);
    const translate = customTranslate || tkPrefix && translateWithCustomTK || componentTranslate;

    return useCallback((error: unknown, defaultMessage?: string): string => {
        const systemError = translate('playtech.mobile.system.systemError', 'System error');

        if (error && typeof error === 'object' && !Array.isArray(error)) {
            const {
                actions,
                errorCode,
                userErrors,
                errorMessage,
                playerMessage,
                customError
            } = (error as IServerError).data || (error as { response: IServerError })?.response?.data || {};

            const userError = Array.isArray(userErrors)
                ? userErrors?.[0]?.message
                : userErrors?.UserError?.[0]?.message;
            const actionMessage = (actions as IServerErrorActions)?.PlayerActionShowMessage?.[0]?.message
                || (actions as IServerErrorActions)?.showMessageNotificationInfo?.message;
            const spareMessage = playerMessage
                || errorMessage
                || customError && translate(customError, customError)
                || defaultMessage;

            return userError
                || actionMessage
                || translate(`error.${errorCode}`, spareMessage ?? systemError);
        }

        return systemError;
    }, [translate]);
};
